import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Newspaper, GraduationCap, Stethoscope } from "lucide-react";
import { API_URL } from "../config";
import { SPECIALTIES } from "../SpecialtyContext";

const KIND_CONFIG = {
  articles: { endpoint: "posts", path: "articles", label: "Статья", icon: Newspaper, color: "#007c84", bodyField: "content" },
  cases:    { endpoint: "cases", path: "cases", label: "Случай", icon: Stethoscope, color: "#e5005b", bodyField: "content" },
  lectures: { endpoint: "lectures", path: "lectures", label: "Материал", icon: GraduationCap, color: "#15803d", bodyField: "description" },
};

const LINK_RE = /\/(articles|cases|lectures)\/(\d+)/;

/** Ищет в тексте сообщения ссылку на статью/случай/материал портала и рендерит
 * превью-карточку вместо/вместе с сырым текстом ссылки. */
export function extractContentLink(text) {
  if (!text) return null;
  const m = text.match(LINK_RE);
  if (!m) return null;
  return { kind: m[1], id: Number(m[2]) };
}

function preview(text, len = 120) {
  if (!text) return "";
  const plain = text
    .replace(/!\[[^\]]*\]\([^)]*\)/g, "")
    .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/[#*_`>\-[\]]/g, "")
    .trim();
  return plain.length > len ? plain.slice(0, len) + "…" : plain;
}

export default function ChatContentPreview({ kind, id }) {
  const cfg = KIND_CONFIG[kind];
  const [item, setItem] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!cfg) return;
    fetch(`${API_URL}/${cfg.endpoint}/${id}`)
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(setItem)
      .catch(() => setError(true));
  }, [cfg, id]);

  if (!cfg || error) return null;
  if (!item) return null;

  const Icon = cfg.icon;
  const specialtyLabel = SPECIALTIES.find(s => s.id === item.specialty)?.label;

  return (
    <Link to={`/${cfg.path}/${id}`} style={{ textDecoration: "none", color: "inherit", display: "block" }}>
      <div style={{
        border: `1px solid ${cfg.color}33`, borderLeft: `3px solid ${cfg.color}`,
        borderRadius: 8, padding: "8px 10px", background: `${cfg.color}0d`,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 3 }}>
          <Icon size={13} strokeWidth={2.2} style={{ color: cfg.color, flexShrink: 0 }} />
          <span style={{ fontSize: "0.74rem", fontWeight: 700, color: cfg.color }}>{cfg.label}</span>
          {specialtyLabel && <span style={{ fontSize: "0.72rem", color: "#888" }}>· {specialtyLabel}</span>}
        </div>
        <div style={{ fontWeight: 700, fontSize: "0.9rem", color: "#222", marginBottom: 2 }}>{item.title}</div>
        {item[cfg.bodyField] && (
          <div style={{ fontSize: "0.8rem", color: "#666", lineHeight: 1.4 }}>{preview(item[cfg.bodyField])}</div>
        )}
      </div>
    </Link>
  );
}
